const state = {
};
const getters = {
};
const mutations = {
};
const actions = {
};

export default { namespaced: false, state, getters, mutations, actions };